export const dayPickerInputPortalContentClassName = 'day-picker-input-portal-content';
